import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DataTeams } from '../../components/Teams/types';
import { useRouter } from '../../helpers/customHooks';
import * as actions from '../actions/teams';

import { RootState } from '../reducers';

type RouterParams = {
  match: {
    id: string;
    conference: string;
  }
};

export const useDataTeamsState = () => {
  const { match } = useRouter<RouterParams>();
  const dataTeams = useSelector((state: RootState) => state.dataTeams) as DataTeams;

  const { conference, id } = match.params;
  return { 
    dataTeams,
    dataTeam: dataTeams[conference] && dataTeams[conference][id]
   };
};

export const useDataTeamsDispatch = () => {
  const dispatch = useDispatch();
  return {
    ...bindActionCreators({ ...actions }, dispatch)
  };
};